export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const accountTypes = [
  {
    id: "Internal",
    text: "Internal",
  },
  {
    id: "External",
    text: "External",
  },
];

export const accountStatus = [
  {
    id: "Active",
    text: "Active",
  },
  {
    id: "Block",
    text: "Block",
  },
];

export const assignmentList = [
  {
    id: "CIT",
    text: "CIT",
  },
  {
    id: "ATM",
    text: "ATM",
  },
  {
    id: "HUB",
    text: "HUB",
  },
  {
    id: "FLM",
    text: "FLM",
  },
  {
    id: "Customer",
    text: "Customer",
  },
  {
    id: "NA",
    text: "NA",
  },
];

export const CUSTOMER_TYPES = [
  { id: "Bank", text: "Bank" },
  { id: "Retail", text: "Retail" },
  { id: "Exchange House", text: "Exchange House" },
  { id: "Corporate", text: "Corporate" },
  { id: "Hotel", text: "Hotel" },
  { id: "Customer", text: "Customer" },
];

export const CUSTOMER_STATUS = [
  { id: "Active", text: "Active" },
  { id: "In Active", text: "In Active" },
];

export const INSURANCE_TYPE = [
  {
    id: "Cash Center",
    text: "Cash Center",
  },
  {
    id: "Central Bank",
    text: "Central Bank",
  },
  {
    id: "ATM",
    text: "ATM",
  },
  {
    id: "BDM",
    text: "BDM",
  },
  {
    id: "Branch",
    text: "Branch",
  },
  {
    id: "Corporate Customer",
    text: "Corporate Customer",
  },
];

export const contractStatus = [
  { id: "active", text: "Active" },
  { id: "closed", text: "Closed" },
];

export const ESCALATION_LEVELS = [
  { id: "1", text: "Level 1" },
  { id: "2", text: "Level 2" },
  { id: "3", text: "Level 3" },
];

export const SERVICE_TYPES = [
  {
    id: "ATM Replenishment",
    text: "ATM Replenishment",
  },
  {
    id: "Machine Clearance",
    text: "Machine Clearance",
  },
  {
    id: "Cash Collection",
    text: "Cash Collection",
  },
  {
    id: "Cash Delivery",
    text: "Cash Delivery",
  },
  { id: "B2B Services", text: "B2B Services" },
  {
    id: "FLM",
    text: "FLM",
  },
  {
    id: "SLM",
    text: "SLM",
  },
];
export const ACTIVITY_TYPES = [
  {
    id: "FLM",
    text: "FLM",
  },
  {
    id: "SLM",
    text: "SLM",
  },
];
export const CASSETTES_TYPE = [
  {
    id: "Type 1",
    text: "Type 1",
  },
  {
    id: "Type 2",
    text: "Type 2",
  },
  {
    id: "Type 3",
    text: "Type 3",
  },
];
export const DENOMINATION_SHAPE = [
  { id: "Notes", text: "Notes" },
  { id: "Coins", text: "Coins" },
];
export const customerInfoDefault = {
  clientId: "",
  name: "",
  shortName: "",
  customerType: null,
  customerCode: "",
  status: CUSTOMER_STATUS[0],
  hasSeparateDispenseCount: false,
  requiresEVhr: false,
};
export const accountDefault = {
  title: "",
  accountNo: "",
  branchCode: "",
  accounts: [],
};

export const contactPersonDefault = {
  firstName: "",
  lastName: "",
  mobileNo: "",
  email: "",
  personalMobileNo: "",
  officeNo: "",
  designation: "",
};

export const insuranceDefault = {
  type: "",
  currency: "",
  pavement: "0",
  van: "0",
  bag: "0",
};
export const denominationDefault = {
  currency: null,
  multiple: null,
  noOfCassettes: "0",
  noOfNotes: "0",
};
export const replenishmentModelsDefault = {
  code: "",
  ...denominationDefault,
  denominations: [],
  models: [],
};
export const contractSLADefault = {
  country: "",
  region: "",
  serviceType: "",
  activityType: "",
  responseTime: "",
  attendedTime: "",
  resolutionTime: "",
};
export const invoicingCatalogDefault = {
  invoicingCode: "",
  currency: "",
  rate: "0",
  discount: "0",
};

export const contractsDefault = {
  ...contractSLADefault,
  ...invoicingCatalogDefault,
  contractCode: "",
  autoRenew: true,
  autoRenewFor: "0",
  startDate: new Date(),
  endDate: new Date(),
  status: contractStatus[0],
  contractSLAs: [],
  invoicingCatalogs: [],
};
export const cassettesDefault = {
  description: "",
  cassetteCurrency: "",
  cassetteMultiple: "",
  cassetteType: "",
  maker: "",
  limit: "0",
  dualScanning: true,
};
export const servicesDenominationDefault = {
  denominationCurrency: "",
  denominationMultiple: "",
  shape: "",
  version: "",
};
export const offeredServicesDefault = {
  serviceName: "",
  denominations: [],
  cassettes: [],
  offeredServices: [],
  ...servicesDenominationDefault,
  ...cassettesDefault,
};
export const escalationGroupDefault = {
  region: "",
  routeNo: "",
  escalationLevel: "",
  inAppRecipient: "",
  emailRecipient: "",
  callRecipient: "",
  inAppRecipients: [],
  emailRecipients: [],
  callRecipients: [],
};
export const emptyCustomer = {
  ...customerInfoDefault,
  accounts: [],
  contactPersons: [],
  insuranceLimits: [],
  replenishmentModels: [],
  contracts: [],
  offeredServices: [],
  escalationGroups: [],
};

export const formValidationRules = {};
export const SERVICES_NAME = [
  { id: "Replenishment", text: "Replenishment" },
  { id: "Clearance", text: "Clearance" },
  {
    id: "Kiosk",
    text: "Kiosk",
  },
];
